// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react';
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {
    AddLocationAlt,
    CheckCircle, Edit,
    Feed,
    Inventory,
    ListAlt,
    LocationOn,
    Logout,
    Notifications,
    ReceiptLong,
    Settings,
    StarRate
} from '@mui/icons-material';
import {useTranslation} from "react-i18next";

// کامپوننت های داشبورد
import Address from "./address";
import NavBar from "../../components/NavBar";
import Comments from "./comments";
import RequestFactor from "./requestFactor";
import Affiliate from "./affiliate";
import Setting from "./setting";
import OrderList from "../orderList";
import ListAddress from "./listAddress";
import {useDispatch, useSelector} from "react-redux";
import {setActiveMenu} from "../../redux/dashboard/actions";
import OrdersOthers from "../ordersOthers";
import MyRequests from "./myRequests";
import Complaint from "../complaint";
import HandleFetchData from "../../plugin/HandleFetchData";
import PostexRate from "../postexRate";
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

export default function Dashboard() {
    // جابه جایی بین صفحات در متد ها
    const navigate = useNavigate();
    const tokenStorage = localStorage.getItem('token')
    const dispatch = useDispatch();
    const selector = useSelector((st) => st?.dashboard)
    // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
    const {t} = useTranslation()
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const {fetchData} = HandleFetchData()

    // متغیر و useState های لوکال صفحه
    const [userInfo, setUserInfo] = React.useState(null)
    const [uploadedImage, setUploadedImage] = React.useState(null);

    React.useEffect(() => {
        setUserInfo(JSON.parse(localStorage.getItem('info-user')))
    }, [])


    const logOut = async () => {
        await localStorage.removeItem("info-user")
        await localStorage.removeItem("token")
        await localStorage.removeItem("token-id")
        await localStorage.setItem('access_login', false)
        navigate('/auth/login', {replace: true})
    }
    const logIn = async () => {
        navigate('/auth/login', {replace: true})
    }

    const handleSelectImage = (event) => {
        const file = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
            setUploadedImage(fileReader.result);
            handleUploadImage(fileReader.result)
        });
        fileReader.readAsDataURL(file);
    }


    const handleUploadImage = async (img) => {
        const data = new FormData();
        data.append('image', img);
        let fetch = await fetchData('', 'POST', '/uploadAvatar', data, "application/json", '', '', '')
    }



    return (
        <>
            <NavBar/>

            <div className="container-fluid">
                <div className="dashboardPage ">
                    <div className="row">
                        <div className="col-12 col-lg-3">
                            <div className="sideBar">

                                <section className="s1">
                                    {/*کامپوننت نوبار*/}
                                    <div className="infoUser _desktopSection">
                                        <div className="selectIMG">
                                            <label htmlFor="upload-avatar">
                                                <img
                                                    src={uploadedImage ? uploadedImage : require('./../../assets/img/user.png')}
                                                    alt="user" loading="lazy"/>

                                                <div className="edit-icon">
                                                    <Edit/>
                                                </div>
                                            </label>
                                            <input type="file" onChange={handleSelectImage} id="upload-avatar"
                                                   accept="image/*"/>
                                        </div>

                                        <h5>{(userInfo?.FullName) ? userInfo?.FullName : t("navBar.t8")}</h5>
                                        <p>{userInfo?.Mobile || '-'}</p>
                                        <p>{userInfo?.Email || '-'}</p>


                                        {/*<div className="level">*/}
                                        {/*  <span>کاربر سطح طلایی</span>*/}
                                        {/*  <Level/>*/}
                                        {/*</div>*/}
                                    </div>
                                </section>

                                {/*Mobile Item*/}
                                <section className="s2 d-block d-lg-none">
                                    <Link to={{pathname: 'address', search: location?.search}} id="addressLink"
                                          className="item">
                                        <>
                                            <div>
                                                <AddLocationAlt/>
                                                <span>{t("dashboard.sideBar.t1")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'listAddress', search: location?.search}} id="listAddressLink"
                                          className="item">
                                        <>
                                            <div>
                                                <LocationOn/>
                                                <span>{t("dashboard.sideBar.t8")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'comments', search: location?.search}} id="commentsLink"
                                          className="item">
                                        <>
                                            <div>
                                                <Notifications/>
                                                <span>{t("dashboard.sideBar.t2")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: '/orderList', search: location?.search}} id="orderListLink"
                                          className="item">
                                        <>
                                            <div>
                                                <Inventory/>
                                                <span>{t("dashboard.sideBar.t3")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: '/ordersOthers', search: location?.search}}
                                          id="ordersOthersLink" className="item">
                                        <>
                                            <div>
                                                <Inventory/>
                                                <span>{t("dashboard.sideBar.t9")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: '/complaint', search: location?.search}} id="complaintLink"
                                          className="item">
                                        <>
                                            <div>
                                                <Feed/>
                                                <span>{t("complaint.t1")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: '/myRequests', search: location?.search}} id="myRequestsLink"
                                          className="item">
                                        <>
                                            <div>
                                                <ListAlt/>
                                                <span>{t("dashboard.sideBar.t10")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'requestFactor', search: location?.search}}
                                          id="requestFactorLink" className="item">
                                        <>
                                            <div>
                                                <ReceiptLong/>
                                                <span>{t("dashboard.sideBar.t4")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'presentation', search: location?.search}}
                                          id="presentationLink" className="item">
                                        <>
                                            <div>
                                                <CheckCircle/>
                                                <span>{t("dashboard.sideBar.t5")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'postexRate', search: location?.search}}
                                          id="rateLink" className="item">
                                        <>
                                            <div>
                                                <StarRate/>
                                                <span>{t("rate.t35")}</span>
                                            </div>
                                        </>
                                    </Link>
                                    <Link to={{pathname: 'setting', search: location?.search}} id="settingLink"
                                          className="item">
                                        <>
                                            <div>
                                                <Settings/>
                                                <span>{t("dashboard.sideBar.t6")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </Link>
                                </section>

                                {/*Desktop Item*/}
                                <section className="s2 d-none d-lg-block">
                                    <a onClick={() => dispatch(setActiveMenu(0))} id="addressLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 0 ? 'active' : ''}>
                                                <AddLocationAlt/>
                                                <span>{t("dashboard.sideBar.t1")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(6))} id="listAddressLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 6 ? 'active' : ''}>
                                                <LocationOn/>
                                                <span>{t("dashboard.sideBar.t8")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(1))} id="commentsLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 1 ? 'active' : ''}>
                                                <Notifications/>
                                                <span>{t("dashboard.sideBar.t2")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(2))} id="orderListLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 2 ? 'active' : ''}>
                                                <Inventory/>
                                                <span>{t("dashboard.sideBar.t3")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(7))} id="ordersOthersLink"
                                       className="item">
                                        <>
                                            <div className={selector?.active_menu === 7 ? 'active' : ''}>
                                                <Inventory/>
                                                <span>{t("dashboard.sideBar.t9")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(9))} id="ordersOthersLink"
                                       className="item">
                                        <>
                                            <div className={selector?.active_menu === 9 ? 'active' : ''}>
                                                <Feed/>
                                                <span>{t("complaint.t1")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(8))} id="myRequestsLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 8 ? 'active' : ''}>
                                                <ListAlt/>
                                                <span>{t("dashboard.sideBar.t10")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(3))} id="requestFactorLink"
                                       className="item">
                                        <>
                                            <div className={selector?.active_menu === 3 ? 'active' : ''}>
                                                <ReceiptLong/>
                                                <span>{t("dashboard.sideBar.t4")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(4))} id="presentationLink"
                                       className="item">
                                        <>
                                            <div className={selector?.active_menu === 4 ? 'active' : ''}>
                                                <CheckCircle/>
                                                <span>{t("dashboard.sideBar.t5")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(10))} id="rateLink"
                                       className="item">
                                        <>
                                            <div className={selector?.active_menu === 10 ? 'active' : ''}>
                                                <StarRate/>
                                                <span>{t("rate.t35")}</span>
                                            </div>
                                        </>
                                    </a>
                                    <a onClick={() => dispatch(setActiveMenu(5))} id="settingLink" className="item">
                                        <>
                                            <div className={selector?.active_menu === 5 ? 'active' : ''}>
                                                <Settings/>
                                                <span>{t("dashboard.sideBar.t6")}</span>
                                            </div>
                                            {/*<KeyboardArrowLeft className="arrowLeft"/>*/}
                                        </>
                                    </a>

                                    {/*<SimpleTreeView>*/}
                                    {/*    <TreeItem itemId="grid" label="Data Grid">*/}
                                    {/*        <TreeItem itemId="grid-community" label="@mui/x-data-grid" />*/}
                                    {/*        <TreeItem itemId="grid-pro" label="@mui/x-data-grid-pro" />*/}
                                    {/*        <TreeItem itemId="grid-premium" label="@mui/x-data-grid-premium" />*/}
                                    {/*    </TreeItem>*/}
                                    {/*    <TreeItem itemId="pickers" label="Date and Time Pickers">*/}
                                    {/*        <TreeItem itemId="pickers-community" label="@mui/x-date-pickers" />*/}
                                    {/*        <TreeItem itemId="pickers-pro" label="@mui/x-date-pickers-pro" />*/}
                                    {/*    </TreeItem>*/}
                                    {/*    <TreeItem itemId="charts" label="Charts">*/}
                                    {/*        <TreeItem itemId="charts-community" label="@mui/x-charts" />*/}
                                    {/*    </TreeItem>*/}
                                    {/*    <TreeItem itemId="tree-view" label="Tree View">*/}
                                    {/*        <TreeItem itemId="tree-view-community" label="@mui/x-tree-view" />*/}
                                    {/*    </TreeItem>*/}
                                    {/*</SimpleTreeView>*/}

                                </section>

                                {
                                    tokenStorage ?
                                        /*دکمه خروج از حساب کاربری*/
                                        <div className="btnLogOut">
                                            <button type="button" onClick={() => logOut()} id="logOut">
                                                <span>{t("dashboard.sideBar.t7")}</span>
                                                <Logout/>
                                            </button>
                                        </div>
                                        :
                                        /*دکمه ورود به حساب کاربری*/
                                        <div className="btnLogIn">
                                            <button type="button" onClick={() => logIn()} id="logIn">
                                                <span>{t("navBar.t1")}</span>
                                                <Logout/>
                                            </button>
                                        </div>
                                }


                            </div>
                        </div>

                        {/*کامپوننت های داشبورد*/}
                        <div className="col-12 col-lg-9 d-none d-lg-block">
                            <div className="itemPage">
                                {selector?.active_menu === 0 && <Address/>}
                                {selector?.active_menu === 1 && <Comments/>}
                                {selector?.active_menu === 2 && <OrderList/>}
                                {selector?.active_menu === 3 && <RequestFactor/>}
                                {selector?.active_menu === 4 && <Affiliate/>}
                                {selector?.active_menu === 5 && <Setting/>}
                                {selector?.active_menu === 6 && <ListAddress/>}
                                {selector?.active_menu === 7 && <OrdersOthers/>}
                                {selector?.active_menu === 8 && <MyRequests/>}
                                {selector?.active_menu === 9 && <Complaint/>}
                                {selector?.active_menu === 10 && <PostexRate/>}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
